<template>
  <div>
    <domain-dialog
      v-model="isDomainDialogOpened"
      :domain="selectedDomain"
      :maker="maker"
      @save="stateSave"
      @close="resetSelectedDomain"/>
    <delete-domain-dialog
      v-model="isDeleteDomainDialogOpened"
      :domain="selectedDomain"
      @delete="stateDelete"
      @close="resetSelectedDomain"/>
    <v-row no-gutters align="center" class="content-header">
      <span class="font-weight-bold">Domaines</span>
      <v-spacer></v-spacer>
      <v-btn :disabled="!$canWrite" dark color="primary" elevation="0" @click="$canWrite && (isDomainDialogOpened = true)" v-if="admin">
        <v-icon left>add</v-icon>
        Nouveau domaine
      </v-btn>
    </v-row>
    <slot name="beforeList" />
    <n-card v-if="isFetching">
      <v-row no-gutters justify="center" align="center" class="my-8">
        <v-progress-linear
          color="primary"
          indeterminate
          rounded
          height="6"
          style="max-width: 200px;"
        ></v-progress-linear>
      </v-row>
    </n-card>
    <n-card v-else-if="!domains.length">
      <v-row no-gutters justify="center" align="center" class="pa-4 text--secondary" style="min-height: 100px;">
        Aucun domaine
      </v-row>
    </n-card>
    <div class="page-main-content" v-else>
      <v-simple-table class="pt-5">
        <thead>
          <tr>
            <th class="text-left">Nom</th>
            <th/>
          </tr>
        </thead>
        <tbody>
          <tr v-for="domain in domains" :key="domain.name">
            <td>{{ domain.name }}</td>
            <td class="text-right admin-list-actions">
              <v-btn :disabled="!$canWrite" icon small @click="$canWrite && (saveDomain(domain))" v-if="admin">
                <v-icon>edit</v-icon>
              </v-btn>
              <!-- <v-btn icon small>
                <v-icon :disabled="!$canWrite" color="red" @click="$canWrite && (deleteDomain(domain))">delete</v-icon>
              </v-btn> -->
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import DomainDialog from '@/components/Domain/DomainDialog.vue';
import DeleteDomainDialog from '@/components/Domain/DeleteDomainDialog.vue';

export default {
  name: `SettingsDomains`,
  props: {
    maker: Object,
    admin: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: () => ({
    isFetching: true,
    isDomainDialogOpened: false,
    isDeleteDomainDialogOpened: false,
    selectedDomain: {},
  }),
  computed: {
    ...mapState(`model/domain`, [
      `makerDomains`,
    ]),
    domains() {
      return _.sortBy(this.makerDomains || [], domain => _.toLower(domain.name));
    },
  },
  methods: {
    saveDomain(domain) {
      this.selectedDomain = domain;
      this.isDomainDialogOpened = true;
    },
    deleteDomain(domain) {
      this.selectedDomain = domain;
      this.isDeleteDomainDialogOpened = true;
    },
    async fetchDomains() {
      // await this.$store.dispatch(`model/client/fetchCompany`);
      // this.$store.dispatch(`model/domain/fetchMakerDomains`);
      this.isFetching = true;
      this.$store.commit(`model/domain/SET_MAKER_DOMAINS`, []);
      await this.$store.dispatch(`model/domain/fetchMakerDomains`, this.maker.id);
      this.isFetching = false;
    },
    async stateSave() {
      await this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: this.selectedDomain && this.selectedDomain.id ? `Domaine modifié avec succès` : `Domaine créé avec succès`,
      });
      this.selectedDomain = {};
    },
    async stateDelete() {
      await this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Domaine supprimé avec succès`,
      });
      this.selectedDomain = {};
    },
    resetSelectedDomain() {
      this.selectedDomain = {};
    },
  },
  mounted() {
    this.fetchDomains();
  },
  components: {
    DomainDialog,
    DeleteDomainDialog,
  },
};
</script>

<style lang="scss">
</style>
